<template>
  <Login v-if="authMode === 'login' || authMode === null" @switchMode="switchMode"></Login>
  <Register v-if="authMode === 'register'" @switchMode="switchMode"></Register>
  <RegisterCode v-if="authMode === 'registerCode'" @switchMode="switchMode"></RegisterCode>
  <RegisterSuccess v-if="authMode === 'registerSuccess'" @switchMode="switchMode" @resubscribePage="resubscribePage"></RegisterSuccess>
  <Restore v-if="authMode === 'restore'" @switchMode="switchMode"></Restore>
  <RestoreCode v-if="authMode === 'restoreCode'" @switchMode="switchMode"></RestoreCode>
  <RestoreConfirm v-if="authMode === 'restoreConfirm'" @switchMode="switchMode"></RestoreConfirm>
  <RestoreSuccess v-if="authMode === 'restoreSuccess'" @switchMode="switchMode" @resubscribePage="resubscribePage"></RestoreSuccess>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import Login from "./auth/Login.vue";
import Register from "./auth/Register.vue";
import RegisterCode from "./auth/RegisterCode.vue";
import RegisterSuccess from "./auth/RegisterSuccess.vue";
import Restore from "./auth/Restore.vue";
import RestoreCode from "./auth/RestoreCode.vue";
import RestoreConfirm from "./auth/RestoreConfirm.vue";
import RestoreSuccess from "./auth/RestoreSuccess.vue";

defineOptions({
  name: 'ComponentsAuth',
});

const emit = defineEmits<{
  resubscribePage: []
}>();

const store = useStore();

const authMode = computed(() => store.state.auth.authMode);

const setAuthMode = (mode: string): void => {
  store.dispatch('auth/setAuthMode', mode);
};

const switchMode = (mode: string): void => {
  setAuthMode(mode);
};

const resubscribePage = (): void => {
  emit('resubscribePage');
};
</script>

<style scoped>

</style>